/**
 * Button — bouton stylisé selon l'identité Mon Ministère.
 * Primary : dégradé or → or clair, texte sombre, radius 10px.
 */
import { colors, fonts, goldGradient } from "../styles/tokens";

const VARIANTS = {
  primary: {
    bg: goldGradient,
    color: colors.bg,                                          // texte sombre sur fond or
    border: "transparent",
    hoverBg: "linear-gradient(135deg, #F5C55A 0%, #E4A72C 100%)",
    shadow: "0 4px 20px rgba(228,167,44,0.40)",
  },
  secondary: {
    bg: colors.card,
    color: colors.text,
    border: colors.border,
    hoverBg: colors.cardHover,
    shadow: "none",
  },
  ghost: {
    bg: "transparent",
    color: colors.text,
    border: colors.border,
    hoverBg: colors.goldDim,
    shadow: "none",
  },
  danger: {
    bg: "rgba(224,91,106,0.12)",
    color: colors.rose,
    border: "rgba(224,91,106,0.4)",
    hoverBg: "rgba(224,91,106,0.2)",
    shadow: "none",
  },
};

const SIZES = {
  sm: { padding: "6px 12px",  fontSize: "13px", height: "32px" },
  md: { padding: "10px 18px", fontSize: "14px", height: "40px" },
  lg: { padding: "14px 24px", fontSize: "16px", height: "48px" },
};

export default function Button({
  children,
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  fullWidth = false,
  type = "button",
  onClick,
  style = {},
  ...rest
}) {
  const palette = VARIANTS[variant] || VARIANTS.primary;
  const sizing  = SIZES[size] || SIZES.md;

  const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    background: palette.bg,
    color: palette.color,
    border: `1px solid ${palette.border}`,
    borderRadius: "10px",                                      // radius officiel
    fontFamily: fonts.body,
    fontWeight: 600,
    letterSpacing: "0.01em",
    cursor: disabled || loading ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    boxShadow: palette.shadow,
    transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1)",
    width: fullWidth ? "100%" : "auto",
    whiteSpace: "nowrap",
    ...sizing,
    ...style,
  };

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      style={baseStyle}
      onMouseEnter={(e) => {
        if (!disabled && !loading) {
          e.currentTarget.style.background = palette.hoverBg;
          if (variant === "primary") e.currentTarget.style.transform = "translateY(-1px)";
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && !loading) {
          e.currentTarget.style.background = palette.bg;
          e.currentTarget.style.transform = "translateY(0)";
        }
      }}
      {...rest}
    >
      {loading ? (
        <span
          style={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            border: "2px solid currentColor",
            borderTopColor: "transparent",
            animation: "spin 0.7s linear infinite",
          }}
        />
      ) : (
        children
      )}
    </button>
  );
}
